import { Injectable } from '@angular/core';
import { Maybe } from '@orderna/admin-panel/src/types/maybe';
import { QueryOptions } from '@orderna/admin-panel/src/types/query-options';
import {
  Data,
  deleteItem,
  deleteItems,
} from '@orderna/admin-panel/src/utils/service';
import { BehaviorSubject, Observable } from 'rxjs';
import { IPurchase, Purchase } from '../../model/purchase';
import { IPurchasesApiService } from './purchases-api.interface';
import { CreatePurchaseRequestDto } from './dtos/commands/create-purchase.request.dto';
import { CreatePurchaseResponseDto } from './dtos/commands/create-purchase.response.dto';
import { UpdatePurchaseRequestDto } from './dtos/commands/update-purchase.request.dto';
import { UpdatePurchaseResponseDto } from './dtos/commands/update-purchase.response.dto';

@Injectable({
  providedIn: 'root',
})
export class PurchasesMockApiService implements IPurchasesApiService {
  data = {
    purchases: {
      items: [],
      queryOptions: { page: 1, size: 10 } as QueryOptions<IPurchase>,
      subject: new BehaviorSubject<Maybe<Purchase[]>>(null),
      totalSubject: new BehaviorSubject<Maybe<number>>(null),
      totalAfterFilterSubject: new BehaviorSubject<Maybe<number>>(null),
    },
  };

  get purchaseData() {
    return this.data['purchases'] as Data<Purchase, IPurchase>;
  }

  createPurchase(
    data: CreatePurchaseRequestDto
  ): Promise<CreatePurchaseResponseDto> {
    throw new Error('Method not implemented.');
  }

  updatePurchase(
    purchaseId: number,
    data: UpdatePurchaseRequestDto
  ): Promise<UpdatePurchaseResponseDto> {
    throw new Error('Method not implemented.');
  }

  deletePurchase(purchaseId: Purchase['id']): Observable<IPurchase> {
    return deleteItem(this.purchaseData, purchaseId);
  }

  deletePurchases(purchaseIds: Purchase['id'][]): Observable<IPurchase[]> {
    return deleteItems(this.purchaseData, purchaseIds);
  }
}
